export enum FormSubmissionFilterType {
    SEARCH_TERM = 'searchTerm',
    SAVED_TO_PMS = 'savedToPms',
    STATUS = 'status',
    DATE = 'date'
  }
  